import { eachDayOfInterval, isWeekend } from 'date-fns';

// Kept in sync manually with functions/server/utils/getNumberOfWorkingDays.js.
export const getNumberOfWorkingDays = (startDate, endDate) => {
  // eachDayOfInterval throws on an invalid date and silently reverses a backwards one.
  if (Number.isNaN(Number(startDate)) || Number.isNaN(Number(endDate))) return 0;
  if (endDate < startDate) return 0;

  const days = eachDayOfInterval({ start: startDate, end: endDate });
  return days.filter(day => !isWeekend(day)).length;
};
